import styled from 'styled-components'
const historyOrderBg = require('../../images/historyOrderBg.png')

export const OutSideWrapper = styled.div`
  .bghistoryOrderBg{
    background: url(${historyOrderBg}) no-repeat center 35%;
    background-size: 70% 42%;
  }
  .g7c{
    color:#7c7c7c;
  }
`
export const HeaderWrapper = styled.div`
  padding: 1% 3% 0;
  .rdsbottom{
    border-bottom-left-radius: 30px;
  }
`
export const OrderWrapper = styled.div`
  padding: 3%;
  margin-top:-2.5rem;
`
export const ListItem = styled.div`
  padding:3%;
  box-shadow: 2.47px 2.47px 1.76px rgba(206,206,206,0.5);
  .gf5{
    color:#f5f5f5;
  }
`
